import React from "react";
function checkLogIn() {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    return isLoggedIn ? true : false;
}
export const UserContext = React.createContext({ checkLogIn })